export default __webpack_public_path__ + "static/media/icon_rent.df8efb02.svg";